import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { schoolRegistrationRequestService } from "./schoolregistrationrequest.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistrationRequest } from 'src/app/Models/registrationrequest.model';
declare var $: any;

@Component({
  selector: 'app-schoolregistrationrequest',
  templateUrl: './schoolregistrationrequest.component.html',
  styleUrls: ['./schoolregistrationrequest.component.css']
})
export class SchoolregistrationrequestComponent implements OnInit {
  @ViewChild('RegistrationForm') RegistrationForm: NgForm;
  responseData: any;
  data: RegistrationRequest;
  boards: any;
  mediums: any;
  institutetypes: any;
  typeOfTrusts: any;
  dropDownData: any;
  offices: any;
  sections: any;
  states: any;
  cities: any;
  types: any;
  locations: any;
  infrastructures: any;
  designations: any;
  hid_trusteeDetailID: any = -1;
  hid_InfrastructureDetailID: any = -1;
  hid_EmployeeDetailID: any = -1;
  TrusteeDetail: Array<any> = [];
  documentList: Array<any> = [];
  InfrastructureDetail: Array<any> = [];
  EmployeeDetail: Array<any> = [];
  doc: any;
  fileextension: any;
  // btnsubmittext:any;
  visibleAquireDate: boolean = false;
  visibleAffiliation: boolean = false;
  standardList: Array<any> = [];
  employeetypes: any;
  infraname: any;

  constructor(private service: schoolRegistrationRequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    this.data = new RegistrationRequest();
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/aciadmin']);
      return;
    }

    this.fillBoard();
    this.fillMediums();
    this.fillInstituteType();
    this.fillOffice();
    this.fillTypeOfTrust();
    this.fillSection();
    this.fillState();
    this.fillSchoolType();
    this.fillSchoolLocation();
    this.fillInfrastructure();
    this.fillEmployeeType();

    if (this.rout.snapshot.paramMap.has('ID')) {
      this.data.HashCode = this.rout.snapshot.paramMap.get('ID');
      setTimeout(() => { this.fillRegistrationDetail(); }, 1500);
    } else {
      this.spinner.hide();
      this.router.navigate(['/schoolregistrationrequestlist']);
    }

    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#RegistrationDate').attr('max', maxDate);
    $('#AcquiredDate').attr('max', maxDate);
    $('#AffiliationNumberAcquireDate').attr('max', maxDate);
  }

  fillBoard() {
    const data = {
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.boards.splice(0, 1);
      });
  }
  
  fillMediums() {
    const data = {
      HashCode: ""
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.mediums.splice(0, 1);
        // this.data.Medium = 0;
      });
  }

  fillInstituteType() {
    const data = {
    };
    this.service.fillInstituteType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.institutetypes = this.dropDownData.dropdownlist;
        this.institutetypes.splice(0, 1);
      });
  }

  fillOffice() {
    const data = {
    };
    this.service.fillOffice(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.offices = this.dropDownData.dropdownlist;
        this.data.Office = 0;
      });
  }

  fillTypeOfTrust() {
    const data = {
    };
    this.service.fillTypeOfTrust(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.typeOfTrusts = this.dropDownData.dropdownlist;
        this.data.TypeOfTrust = 0;
      });
  }

  fillSection() {
    const data = {
    };
    this.service.fillSection(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.sections = this.dropDownData.Sectionlist;
        // this.data.Section = 0;
      });
  }

  fillState() {
    const data = {
    };
    this.service.fillState(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.states = this.dropDownData.dropdownlist;
        this.data.State = 12;
        this.fillCity();
      });
  }

  fillCity() {
    const data = {
      stateID: this.data.State
    };
    this.service.fillCity(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.cities = this.dropDownData.dropdownlist;
        if (this.data.City == 0 || this.data.City == undefined)
          this.data.City = 0;
      });
  }

  fillSchoolType() {
    const data = {
    };
    this.service.fillSchoolType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.types = this.dropDownData.dropdownlist;
        this.data.SchoolType = 0;
      });
  }
  fillSchoolLocation() {
    const data = {
    };
    this.service.fillSchoolLocation(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.locations = this.dropDownData.dropdownlist;
        this.data.SchoolLocation = 0;
      });
  }


  fillInfrastructure() {
    const data = {
    };
    this.service.fillInfrastructure(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.infrastructures = this.dropDownData.dropdownlist;
        this.data.InfrastructureID = 0;
      });
  }

  fillEmployeeType() {
    const data = {
    };
    this.service.fillEmployeeType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.employeetypes = this.dropDownData.dropdownlist;
        this.data.EmployeeTypeID = 0;
      });
  }

  blockSpecialChar(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57) || k == 91 || k == 93 || k == 45 || k == 32 || k == 92 || k == 47);
  }

  uploadImage(event, i) {
    if (event.target.files.length > 0) {
      this.doc = event.target.files[0];
      if (Math.round(this.doc.size / 1024) > 1000) {
        this.toastr.error("File size can't be greater then 1 MB");
        return;
      }
      this.fileextension = this.doc.name.split('.');
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "png"
        && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpeg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "pdf") {
        this.toastr.error("You can upload only jpg, jpeg, png or pdf file");
        return;
      }
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() == "pdf") {
        document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
      }
      //else {
      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        document.getElementById("preview_" + i).setAttribute("src", reader.result as string);
        if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() == "pdf") {
          document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
        }
        this.documentList[i]["Document"] = reader.result as string;
        //this.establishmentDetailList[i]["ViewURL"] = reader.result as string;
        this.documentList[i]["Extension"] = "." + this.fileextension[this.fileextension.length - 1].toString().toLowerCase();
        //}
      }
    } else {
      this.doc = "";
      this.documentList[i]["Document"] = "";
      this.documentList[i]["ViewURL"] = "assets/images/no-image.jpg";
      this.documentList[i]["downloadURL"] = "assets/images/no-image.jpg";
      this.documentList[i]["Extension"] = "";
    }
  }

  // displayAquireDate() {
  //   this.visibleAquireDate = false;
  //   for (var i = 0; i < this.sections.length; i++) {
  //     var j = $('#chksection' + i).is(":checked");
  //     if (j == true && parseInt(this.sections[i]["value"]) > 2) {
  //       this.visibleAquireDate = true;
  //     }
  //   }
  // }

  // displayAffiliation(){
  //   var j = $('#chkBoard' + 1).is(":checked");
  //   if(j){
  //     this.visibleAffiliation= true;
  //   }else{
  //     this.visibleAffiliation= false;
  //     this.data.AffiliationNumberAcquireDate= null;
  //     this.data.AffiliationNumber = null;
  //   }
  // }

  async fillRegistrationDetail() {
    this.spinner.show();
    const data = {
      HashCode: this.data.HashCode
    };
    await this.service.fillRegistrationDetail(data)
      .subscribe(data => {
        this.spinner.hide();
        this.responseData = data;
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
          return
        }
        // if(!this.responseData.userRightsStatus){
        //   this.toastr.error(this.responseData.message);
        //  // this.router.navigate(['/aciadmin']);
        //   return;
        // }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/schoolregistrationrequestlist']);
          return
        }
        else {
          this.data = this.responseData;
          //this.fillCity();
          for (var i = 0; i < this.boards.length; i++) {
            if (this.data.Board.includes(this.boards[i]["value"])) {
              $('#chkBoard' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkBoard' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.mediums.length; i++) {
            if (this.data.Medium.includes(this.mediums[i]["value"])) {
              $('#chkmedium' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkmedium' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.institutetypes.length; i++) {
            if (this.data.InstituteTypeID.includes(this.institutetypes[i]["value"])) {
              $('#chkinstitute' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkinstitute' + i).prop("disabled", true);
          }
          var f = 0;
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.Section.includes(this.sections[i]["value"])) {
              $('#chksection' + i).prop("checked", true);
              if (parseInt(this.sections[i]["value"]) > 2) {
                f++;
              }
            }
            //$('#chksection' + i).prop("disabled", true);
          }
          //this.displayAffiliation();
          if (f > 0) {
            this.visibleAquireDate = true;
          }
          this.TrusteeDetail = this.data.TrusteeDetail;
          this.InfrastructureDetail = this.data.InfrastructureDetail;
          this.EmployeeDetail = this.data.EmployeeDetail;
          this.documentList = this.data.DocumentDetail;

          this.data.EmployeeTypeID = 0;
          this.data.InfrastructureID = 0;

          for (var i = 0; i < this.documentList.length; i++) {
            this.documentList[i]["text"] = this.documentList[i]["Standard"]  + " - " + this.documentList[i]["Medium"] + " Medium" + " - " + this.documentList[i]["InstituteType"];
            this.documentList[i]["Document"] = this.documentList[i]["ViewURL"];
            if (this.documentList[i]["Extension"] != ".jpg" && this.documentList[i]["Extension"] != ".jpeg"
              && this.documentList[i]["Extension"] != ".png") {
              this.documentList[i]["downloadURL"] = "assets/images/pdfimage.jpg";
            } else {
              this.documentList[i]["downloadURL"] = this.documentList[i]["ViewURL"];
            }
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            $("#btnsubmit,#btnreject").css("display","none");
            //this.router.navigate(['/aciadmin']);
            return;
          }
          else{
            $("#btnsubmit,#btnreject").css("display","block");
          }
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/aciadmin']);
      });
  }

  addTrustee() {
    if (this.data.TrusteeName == undefined || this.data.TrusteeName.trim().length == 0) {
      this.toastr.error("Enter Trustee's Name");
      return
    }
    if (this.data.TrusteeAddress == undefined || this.data.TrusteeAddress.trim().length == 0) {
      this.toastr.error("Enter Trustee Address");
      return
    }
    if (this.data.TrusteeMobileNo == undefined || this.data.TrusteeMobileNo.length != 10) {
      this.toastr.error("Enter valid mobile no");
      return
    }
    if (this.data.TrusteeMailID == undefined) {
      this.toastr.error("Enter email id");
      return
    }
    var pattern = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    if (!this.data.TrusteeMailID.match(pattern)) {
      this.toastr.error("Enter valid email id");
      return
    }
    if (parseInt(this.hid_trusteeDetailID) >= 0) {
      this.TrusteeDetail[this.hid_trusteeDetailID] = {
        "TrusteeName": this.data.TrusteeName.trim(), "TrusteeAddress": this.data.TrusteeAddress.trim()
        , "TrusteeMobileNo": this.data.TrusteeMobileNo.trim(), "TrusteeMailID": this.data.TrusteeMailID.trim()
      }
    }
    else {
      for (var i = 0; i < this.TrusteeDetail.length; i++) {
        if (this.data.TrusteeName.trim() == this.TrusteeDetail[i]["TrusteeName"]) {
          this.toastr.error("Trustee's Name already exists");
          return
        }
        if (this.data.TrusteeMobileNo.trim() == this.TrusteeDetail[i]["TrusteeMobileNo"]) {
          this.toastr.error("Mobile No already exists");
          return
        }
        if (this.data.TrusteeMailID.trim() == this.TrusteeDetail[i]["TrusteeMailID"]) {
          this.toastr.error("Trustee's Mail ID already exists");
          return
        }
      }
      this.TrusteeDetail[this.TrusteeDetail.length] = {
        "TrusteeName": this.data.TrusteeName.trim(), "TrusteeAddress": this.data.TrusteeAddress.trim()
        , "TrusteeMobileNo": this.data.TrusteeMobileNo.trim(), "TrusteeMailID": this.data.TrusteeMailID.trim()
      }
    }
    this.clearTrustee();
  }

  editTrustee(i) {
    this.hid_trusteeDetailID = i;
    this.data.TrusteeName = this.TrusteeDetail[i]["TrusteeName"];
    this.data.TrusteeAddress = this.TrusteeDetail[i]["TrusteeAddress"];
    this.data.TrusteeMobileNo = this.TrusteeDetail[i]["TrusteeMobileNo"];
    this.data.TrusteeMailID = this.TrusteeDetail[i]["TrusteeMailID"];
  }

  deleteTrustee(i) {
    this.TrusteeDetail.splice(parseInt(i), 1);
  }

  clearTrustee() {
    this.hid_trusteeDetailID = "-1";
    this.data.TrusteeName = "";
    this.data.TrusteeAddress = "";
    this.data.TrusteeMobileNo = "";
    this.data.TrusteeMailID = "";
  }

  
  addEmployeeDetail() {
    if (this.data.EmployeeTypeID == undefined || this.data.EmployeeTypeID == 0) {
      this.toastr.error("Select employee category");
      return
    }

    if (this.data.TotalPermanentSalary > 0) {
      if ((this.data.NoOfPermanentEmployee == undefined || this.data.NoOfPermanentEmployee == null || this.data.NoOfPermanentEmployee == 0)) {
        this.toastr.error("Enter no of permanent employees");
        return
      }
    }
    if (this.data.TotalAdhocSalary > 0) {
      if ((this.data.NoOfAdhocEmployee == undefined || this.data.NoOfAdhocEmployee == null || this.data.NoOfAdhocEmployee == 0)) {
        this.toastr.error("Enter no of adhoc employees");
        return
      }
    }

    if (this.data.NoOfPermanentEmployee > 0 && (this.data.TotalPermanentSalary == null || this.data.TotalPermanentSalary == 0)) {
      this.toastr.error("Enter total salary of permanent employees");
      return
    }

    if (this.data.NoOfAdhocEmployee > 0 && (this.data.TotalAdhocSalary == null || this.data.TotalAdhocSalary == 0)) {
      this.toastr.error("Enter total salary of adhoc employees");
      return
    }

    var empType = null
    for(var i=0;i<this.employeetypes.length;i++){
      if(this.data.EmployeeTypeID == this.employeetypes[i]["value"]){
        empType = this.employeetypes[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_EmployeeDetailID) >= 0) {
      this.EmployeeDetail[this.hid_EmployeeDetailID] = {
        "EmployeeTypeID": this.data.EmployeeTypeID, "EmployeeType": empType,"NoOfPermanentEmployee": this.data.NoOfPermanentEmployee
        ,"NoOfAdhocEmployee": this.data.NoOfAdhocEmployee,"TotalPermanentSalary": this.data.TotalPermanentSalary,"TotalAdhocSalary": this.data.TotalAdhocSalary
      }
    }
    else {
      for (var i = 0; i < this.EmployeeDetail.length; i++) {
        if (this.data.EmployeeTypeID == this.EmployeeDetail[i]["EmployeeTypeID"]) {
          this.toastr.error("Employee category is already exists");
          return
        }
      }
      this.EmployeeDetail[this.EmployeeDetail.length] = {
        "EmployeeTypeID": this.data.EmployeeTypeID, "EmployeeType": empType,"NoOfPermanentEmployee": this.data.NoOfPermanentEmployee
        ,"NoOfAdhocEmployee": this.data.NoOfAdhocEmployee,"TotalPermanentSalary": this.data.TotalPermanentSalary,"TotalAdhocSalary": this.data.TotalAdhocSalary
      }
    }
    this.clearEmployeeDetail();
  }

  editEmployeeDetail(i) {
    this.hid_EmployeeDetailID = i;
    this.data.EmployeeTypeID = this.EmployeeDetail[i]["EmployeeTypeID"];
    this.data.NoOfPermanentEmployee = this.EmployeeDetail[i]["NoOfPermanentEmployee"];
    this.data.NoOfAdhocEmployee = this.EmployeeDetail[i]["NoOfAdhocEmployee"];
    this.data.TotalPermanentSalary = this.EmployeeDetail[i]["TotalPermanentSalary"];
    this.data.TotalAdhocSalary = this.EmployeeDetail[i]["TotalAdhocSalary"];
  }

  deleteEmployeeDetail(i) {
    this.EmployeeDetail.splice(parseInt(i), 1);
  }

  clearEmployeeDetail() {
    this.hid_EmployeeDetailID = "-1";
    this.data.EmployeeTypeID = 0;
    this.data.NoOfPermanentEmployee = null;
    this.data.NoOfAdhocEmployee = null;
    this.data.TotalPermanentSalary = null;
    this.data.TotalAdhocSalary = null;
  }

  getInfraName(){
    this.infraname = $("#InfrastructureID :selected").text();
    if($.trim(this.infraname.toLowerCase()) == "other"){
      $("#divotherinfra").css("display","block");
    }
    else{
      $("#divotherinfra").css("display","none");
    }
  }

  addInfrastructure() {
    if (this.data.InfrastructureID == undefined || this.data.InfrastructureID == 0) {
      this.toastr.error("Select infrastructure type");
      return
    }

    if (this.data.NoOfInfrastructure == undefined || this.data.NoOfInfrastructure == null || this.data.NoOfInfrastructure == 0) {
      this.toastr.error("Enter no of infrastructure");
      return
    }
    if (this.data.InfrastructureSize == undefined || this.data.InfrastructureSize == null || this.data.InfrastructureSize < 0) {
      this.toastr.error("Enter infrastructure size");
      return
    }
    if(($.trim(this.infraname.toLowerCase()) == "other") && ($.trim(this.data.OtherInfrastructure) == "" || $.trim(this.data.OtherInfrastructure) == undefined)){
      this.toastr.error("Other infrastructure is required");
      return;
    }

    var InfrastructureType = null
    for(var i=0;i<this.infrastructures.length;i++){
      if(this.data.InfrastructureID == this.infrastructures[i]["value"]){
        InfrastructureType = this.infrastructures[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_InfrastructureDetailID) >= 0) {
      this.InfrastructureDetail[this.hid_InfrastructureDetailID] = {
        "InfrastructureID": this.data.InfrastructureID, "InfrastructureType": InfrastructureType,"NoOfInfrastructure": this.data.NoOfInfrastructure, "InfrastructureSize": this.data.InfrastructureSize,
        "OtherInfrastructure": this.data.OtherInfrastructure
      }
    }
    else {
      for (var i = 0; i < this.InfrastructureDetail.length; i++) {
        if(this.InfrastructureDetail[i]["InfrastructureType"] != "Other"){
        if (this.data.InfrastructureID == this.InfrastructureDetail[i]["InfrastructureID"]) {
          this.toastr.error("Infrastructure type is already exists");
          return
        }
      }
        if (this.data.InfrastructureID == this.InfrastructureDetail[i]["InfrastructureID"] && (this.data.OtherInfrastructure == $.trim(this.InfrastructureDetail[i]["OtherInfrastructure"]))) {
          this.toastr.error("Other infrastructure is already exists");
          return
        }
      }
      this.InfrastructureDetail[this.InfrastructureDetail.length] = {
        "InfrastructureID": this.data.InfrastructureID,"InfrastructureType": InfrastructureType, "NoOfInfrastructure": this.data.NoOfInfrastructure, "InfrastructureSize": this.data.InfrastructureSize,
        "OtherInfrastructure": this.data.OtherInfrastructure
      }
    }
    this.clearInfrastructure();
  }

  editInfrastructure(i) {
    this.hid_InfrastructureDetailID = i;
    this.data.InfrastructureID = this.InfrastructureDetail[i]["InfrastructureID"];
    this.data.NoOfInfrastructure = this.InfrastructureDetail[i]["NoOfInfrastructure"];
    this.data.InfrastructureSize = this.InfrastructureDetail[i]["InfrastructureSize"];
    this.data.OtherInfrastructure = this.InfrastructureDetail[i]["OtherInfrastructure"];
    setTimeout(() => { 
      this.getInfraName();
    }, 1000);
  }

  deleteInfrastructure(i) {
    this.InfrastructureDetail.splice(parseInt(i), 1);
  }

  clearInfrastructure() {
    this.hid_InfrastructureDetailID = "-1";
    this.data.InfrastructureID = 0;
    this.data.NoOfInfrastructure = null;
    this.data.InfrastructureSize = null;
    this.data.OtherInfrastructure = null;
  }

  updateRequest(data, status) {
    this.data.Board = "";
    for (var i = 0; i < this.boards.length; i++) {
      var j = $('#chkBoard' + i).is(":checked");
      if (j == true) {
        if (this.data.Board == "")
          this.data.Board += ",";
        this.data.Board += this.boards[i]["value"] + ",";
      }
    }

    this.data.Medium = "";
    for (var i = 0; i < this.mediums.length; i++) {
      var j = $('#chkmedium' + i).is(":checked");
      if (j == true) {
        if (this.data.Medium == "")
          this.data.Medium += ",";
        this.data.Medium += this.mediums[i]["value"] + ",";
      }
    }

    this.data.InstituteTypeID = "";
    for (var i = 0; i < this.institutetypes.length; i++) {
      var j = $('#chkinstitute' + i).is(":checked");
      if (j == true) {
        if (this.data.InstituteTypeID == "")
          this.data.InstituteTypeID += ",";
        this.data.InstituteTypeID += this.institutetypes[i]["value"] + ",";
      }
    }

    this.data.Section = "";
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (this.data.Section == "")
          this.data.Section += ",";
        this.data.Section += this.sections[i]["value"] + ",";
      }
    }

    this.data.Standard = "";
    for (var i = 0; i < this.documentList.length; i++) {
      var j = $('#chkStd' + i).is(":checked");
      if (j == true) {
        if (this.data.Standard == "")
          this.data.Standard += ",";
        this.data.Standard += this.documentList[i]["value"] + ",";
      }
    }

    if (this.data.Board == "" || this.data.Medium == "" || this.data.Section == "" || this.data.InstituteTypeID == ""
     || this.data.Standard == "") {
      return;
    }

    var f = 0;
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (parseInt(this.sections[i]["value"]) > 2) {
          f++;
          break;
        }
      }
    }
    if (f == 0) {
      this.data.AcquiredDate = null;
    }
    if (this.data.Medium == '' || this.data.Medium == undefined || this.data.TypeOfTrust == 0 || this.data.TypeOfTrust == undefined
      || this.data.Section == '' || this.data.Section == undefined || this.data.InstituteTypeID == '' || this.data.InstituteTypeID == undefined || this.data.SchoolLocation == 0 
      || this.data.SchoolLocation == undefined || this.data.SchoolType == 0 || this.data.SchoolType == undefined
      || this.data.State == 0 || this.data.State == undefined
      || this.data.City == undefined || this.data.City == 0) {
      //this.toastr.error('Please fill all details');
      return;
    }
    if (this.TrusteeDetail == undefined || this.TrusteeDetail.length == 0) {
      this.toastr.error("Add atleast one trustee detail");
      return;
    }
    this.data.RequestStatus = status;
    if (this.data.RequestStatus == 2 && (this.data.Remarks == undefined || this.data.Remarks.trim().length == 0)) {
      this.toastr.error("Remark is required while rejecting request");
      return;
    }
    this.data.TrusteeDetail = this.TrusteeDetail;
    for (var i = 0; i < this.documentList.length; i++) {
      if (this.documentList[i]["Document"] == undefined || this.documentList[i]["Document"] == "") {
        this.toastr.error("Please upload document for all course.");
        return;
      }
    }

    this.data.DocumentDetail = this.documentList;
    if (this.RegistrationForm.valid) {
      this.spinner.show();
      this.service.updateRegistrationRequest(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
           // this.router.navigate(['/aciadmin']);
            return;
          }
          else {
            this.toastr.success(this.responseData.message);
            this.RegistrationForm.resetForm();
            this.router.navigate(['/schoolregistrationrequestlist']);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
    // else {
    //   this.toastr.error('Please fill all details');
    //   const invalid = [];
    //   const controls = this.RegistrationForm.controls;
    //   for (const name in controls) {
    //     if (controls[name].invalid) {
    //       invalid.push(name);
    //     }
    //   }
    // }
  }

  redirectToList() {
    this.router.navigate(['/schoolregistrationrequestlist']);
  }
}
